(function () {
    'use strict';

    angular
        .module('AsyncPanel')
        .factory('action-ap-get-component-model', actionFunc);

    function actionFunc($q, lodash, PanelManager) {
        return function(panel, options) {
            return $q.when(run());

            function run() {
                const funcName = lodash.get(options, 'funcName', 'getModel');
                const updateStateFunc = lodash.get(options, 'updateFunc', 'setState');
                const panel_id_override = lodash.get(options, 'panel_id', null);
                const targetted_panel = (panel_id_override) ? PanelManager.get(panel_id_override) : panel;
                if (typeof targetted_panel.panelScope.vm[funcName] === typeof function() {}) {
                    let modelPath = 'model';
                    if (lodash.has(options, 'modelPath')) {
                        modelPath = [modelPath, options.modelPath].join('.')
                    }

                    const optionParams = lodash.get(options, 'params', false);
                    const componentModel = targetted_panel.panelScope.vm[funcName](optionParams);
                    if (lodash.has(options, 'update_panel') && !options.update_panel) {
                        return componentModel;
                    }

                    targetted_panel[updateStateFunc](modelPath, componentModel);
                    return true;
                }
                return false;
            }
        };
    }
})();